const columns = function(num) {
  const ncols = (() => { switch (false) {
    case !(num <= 4): return 2;
    case !(num <= 9): return 3;
    default: return 4;
  } })();

  return ncols;
};

const splitIntoBuckets = function(shopables, numBuckets) {
  const buckets = [];
  for (let num = 0; num < numBuckets; num++) {
    buckets[num] = [];
  }

  let bucketIndex = 0;
  shopables.forEach(function(shopable) {
    if (bucketIndex === numBuckets) {
      bucketIndex = 0;
    }
    buckets[bucketIndex].push(shopable);
    return bucketIndex++;
  });

  return buckets;
};

export default function(shopables) {
  const numBuckets = columns(shopables.length);

  return splitIntoBuckets(shopables, numBuckets);
};
